/**
 * @author: yuanchang@baidu.com
 * @datetime: 2017-05-16 20:23:39
 * @file: 路由配置
 */

import Vue from "vue";
import Router from "vue-router";
import setting from '../pages/setting.vue'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      //redirect: 'datacenter',
      redirect: "admin"
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/pages/login/login"], resolve)
    },
    // 运营平台的路由规则
    {
      path: "/admin",
      name: "admin",
      redirect: {
        name: "admin-affiliate-list"
      },
      component: resolve => require(["@/pages/admin"], resolve),
      children: [
        {
          path: "afflist",
          name: "admin-affiliate-list",
          component: resolve => require(["@/pages/admin/afflist"], resolve)
        },
        {
          path: "afflevel",
          name: "admin-affiliate-afflevel",
          component: resolve => require(["@/pages/admin/afflevel"], resolve)
        },
        {
          path: "affpaylist",
          name: "admin-affiliate-affpaylist",
          component: resolve => require(["@/pages/admin/affpaylist"], resolve)
        },
        {
          path: "affautolevel",
          name: "admin-affiliate-affautolevel",
          component: resolve => require(["@/pages/admin/affautolevel"], resolve)
        },
        {
          path: "advlist",
          name: "admin-advertiser-list",
          component: resolve => require(["@/pages/admin/advlist"], resolve)
        },
        {
          path: "discountmarkuplist",
          name: "admin-advertiser-discountmarkuplist",
          component: resolve =>
            require(["@/pages/admin/discountAndMarkupList"], resolve)
        },
        {
          path: "offerdiscountmarkuplist",
          name: "admin-offer-discountmarkuplist",
          component: resolve =>
            require(["@/pages/admin/offerDiscountAndMarkupList"], resolve)
        },
        {
          path: "advlevel",
          name: "admin-advertiser-advlevel",
          component: resolve => require(["@/pages/admin/advlevel"], resolve)
        },
        {
          path: "advpaylist",
          name: "admin-advertiser-advpaylist",
          component: resolve => require(["@/pages/admin/advpaylist"], resolve)
        },
        {
          path: "offerBlackList",
          name: "admin-advertiser-offerBlackList",
          component: resolve =>
            require(["@/pages/admin/offerBlackList"], resolve)
        },
        {
          path: "offerlist",
          name: "admin-offer-offerlist",
          component: resolve => require(["@/pages/admin/offerlist"], resolve)
        },
        {
          path: "directOffer",
          name: "admin-offer-directOffer",
          component: resolve => require(["@/pages/admin/directOffer"], resolve)
        },
        {
          path: "offerExempt",
          name: "admin-offer-offerExempt",
          component: resolve => require(["@/pages/admin/offerExempt"], resolve)
        },
        {
          path: "offerSmartlink",
          name: "admin-offer-offerSmartLink",
          component: resolve =>
            require(["@/pages/admin/offerSmartLink"], resolve)
        },
        {
          path: "advonoff",
          name: "admin-offer-advonoff",
          component: resolve => require(["@/pages/admin/advonoff"], resolve)
        },
        {
          path: "advdetail",
          name: "admin-offer-advdetail",
          component: resolve => require(["@/pages/admin/advdetail"], resolve)
        },
        {
          path: "offerauth",
          name: "admin-offer-offerauth",
          component: resolve => require(["@/pages/admin/offerAuth"], resolve)
        },
        {
          path: "offerFilter",
          name: "admin-affiliate-offerFilter",
          component: resolve => require(["@/pages/admin/offerFilter"], resolve)
        },
        {
          path: "caplist",
          name: "admin-cap-caplist",
          component: resolve => require(["@/pages/admin/caplist"], resolve)
        },
        {
          path: "caplog",
          name: "admin-cap-caplog",
          component: resolve => require(["@/pages/admin/caplog"], resolve)
        },
        {
          path: "capOffer",
          name: "admin-cap-capOffer",
          component: resolve => require(["@/pages/admin/capOffer"], resolve)
        },
        {
          path: "capDefault",
          name: "admin-cap-capDefault",
          component: resolve => require(["@/pages/admin/capDefault"], resolve)
        },
        {
          path: "blacklist",
          name: "admin-tool-blacklist",
          component: resolve => require(["@/pages/admin/blacklist"], resolve)
        },
        {
          path: "affbalance",
          name: "admin-tool-affbalance",
          component: resolve => require(["@/pages/admin/affbalance"], resolve)
        },
        {
          path: "advbalance",
          name: "admin-tool-advbalance",
          component: resolve => require(["@/pages/admin/advbalance"], resolve)
        },
        {
          path: "affdiscount",
          name: "admin-tool-affdiscount",
          component: resolve => require(["@/pages/admin/affdiscount"], resolve)
        },
        {
          path: "affautodiscount",
          name: "admin-tool-affautodiscount",
          component: resolve =>
            require(["@/pages/admin/affautodiscount"], resolve)
        },
        {
          path: "advdiscount",
          name: "admin-tool-advdiscount",
          component: resolve => require(["@/pages/admin/advdiscount"], resolve)
        },
        {
          path: "advmanualrevenue",
          name: "admin-tool-advmanualrevenue",
          component: resolve =>
            require(["@/pages/admin/advManualRevenue"], resolve)
        },
        {
          path: "advbalanceturnover",
          name: "admin-tool-advbalanceturnover",
          component: resolve =>
            require(["@/pages/admin/advBalanceTurnover"], resolve)
        },
        {
          path: "pricelevel",
          name: "admin-tool-pricelevel",
          component: resolve =>
            require(["@/pages/admin/pricelist"], resolve)
        },
        {
          path: "discountproof",
          name: "admin-tool-discountproof",
          component: resolve =>
            require(["@/pages/admin/discountproof"], resolve)
        },
        {
          path: "affdiscountdetail",
          name: "admin-tool-affdiscountdetail",
          component: resolve =>
            require(["@/pages/admin/affdiscountdetail"], resolve)
        },
        {
          path: "advdiscountdetail",
          name: "admin-tool-advdiscountdetail",
          component: resolve =>
            require(["@/pages/admin/advdiscountdetail"], resolve)
        },
        {
          path: "log",
          name: "admin-tool-log",
          component: resolve => require(["@/pages/admin/loglist"], resolve)
        },
        {
          path: "warninglist",
          name: "admin-warning-warninglist",
          component: resolve => require(["@/pages/admin/warninglist"], resolve)
        }
      ]
    },
    // 数据中心的路由规则
    {
      path: "/datacenter",
      name: "datacenter",
      redirect: {
        name: "datacenter-dashboard-overview"
      },
      component: resolve => require(["@/pages/datacenter"], resolve),
      children: [
        {
          path: "dashboard",
          name: "datacenter-dashboard-overview",
          component: resolve =>
            require(["@/pages/datacenter/dashboard"], resolve)
        },
        {
          path: "profit",
          name: "datacenter-dashboard-profit",
          component: resolve => require(["@/pages/datacenter/profit"], resolve)
        },
        {
          path: "detailAutoDeductList",
          name: "datacenter-dashboard-detailAutoDeductList",
          component: resolve =>
            require(["@/pages/datacenter/detailAutoDeductList"], resolve)
        },
        {
          path: "dailyReport",
          name: "datacenter-dashboard-dailyReport",
          component: resolve =>
            require(["@/pages/datacenter/dailyReport"], resolve)
        },
        {
          path: "exploration",
          name: "datacenter-exploration",
          redirect: {
            name: "datacenter-exploration-overview"
          },
          component: resolve =>
            require(["@/pages/datacenter/exploration"], resolve),
          children: [
            {
              path: "overview",
              name: "datacenter-exploration-overview",
              component: resolve =>
                require(["@/pages/datacenter/exploration/overview"], resolve)
            }
          ]
        },
        {
          path: "miniexploration",
          name: "minidatacenter-exploration",
          redirect: {
            name: "datacenter-miniexploration-overview"
          },
          component: resolve =>
            require(["@/pages/datacenter/miniExploration"], resolve),
          children: [
            {
              path: "overview",
              name: "datacenter-miniExploration-overview",
              component: resolve =>
                require(["@/pages/datacenter/exploration/overview"], resolve)
            }
          ]
        },
        {
          path: "dashboardcash",
          name: "datacenter-dashboard-overview-cash",
          component: resolve =>
            require(["@/pages/datacenter/dashboardcash"], resolve)
        },
        {
          path: "realtimecash",
          name: "datacenter-dashboard-realtimecash",
          component: resolve =>
            require(["@/pages/datacenter/dashboardRealtimeCash"], resolve)
        },
        {
          path: "atvcash",
          name: "datacenter-dashboard-dailyReportcash",
          component: resolve =>
            require(["@/pages/datacenter/dailyReportCash"], resolve)
        },
        {
          path: "pkgcost",
          name: "datacenter-dashboard-pkgManualCost",
          component: resolve =>
            require(["@/pages/datacenter/pkgManualCost"], resolve)
        },
        {
          path: "autocost",
          name: "datacenter-dashboard-dailyCashCostReport",
          component: resolve =>
            require(["@/pages/datacenter/dailyCashCostReport"], resolve)
        },
        {
          path: "ltvcash",
          name: "datacenter-dashboard-ltv-cash",
          redirect: {
            name: "datacenter-exploration-cashoverview"
          },
          component: resolve =>
            require(["@/pages/datacenter/explorationcash"], resolve),
          children: [
            {
              path: "overview",
              name: "datacenter-exploration-cashoverview",
              component: resolve =>
                require(["@/pages/datacenter/exploration/cashoverview"], resolve)
            }
          ]
        }
      ]
    },
    // dsp
    {
      path: "/dsp",
      name: "dsp",
      redirect: {
        name: "dsp-manage-campaign-list"
      },
      component: resolve => require(["@/pages/dsp"], resolve),
      children: [
        {
          path: "campaign",
          name: "dsp-manage-campaign-list",
          component: resolve => require(["@/pages/dsp/campaign"], resolve)
        },
        {
          path: "group",
          name: "dsp-manage-group-list",
          component: resolve => require(["@/pages/dsp/group"], resolve)
        },
        {
          path: "advert",
          name: "dsp-manage-advert-list",
          component: resolve => require(["@/pages/dsp/advert"], resolve)
        },
      ]
    },
    // 反作弊中心的路由规则
    {
      path: "/anti",
      name: "anti",
      redirect: {
        name: "anti-risk-mtti"
      },
      component: resolve => require(["@/pages/anti"], resolve),
      children: [
        {
          path: "mtti",
          name: "anti-risk-mtti",
          component: resolve => require(["@/pages/anti/mtti"], resolve)
        },
        {
          path: "clickqualit",
          name: "anti-qualit-clickqualit",
          component: resolve => require(["@/pages/anti/clickqualit"], resolve)
        },
        {
          path: "activequalit",
          name: "anti-qualit-activequalit",
          component: resolve => require(["@/pages/anti/activequalit"], resolve)
        }
      ]
    },
    // App运营页路由规则
    {
      path: "/application",
      name: "application",
      redirect: {
        name: "fiction-fictionlist"
      },
      component: resolve => require(["@/pages/application"], resolve),
      children: [
        {
          path: "fictionlist",
          name: "fiction-fictionlist",
          component: resolve =>
            require(["@/pages/application/fiction/fictionlist"], resolve)
        },
        {
          path: "fictionDetail",
          name: "fiction-fictionDetail",
          component: resolve =>
            require(["@/pages/application/fiction/fictionDetail"], resolve)
        },
        {
          path: "fictionhot",
          name: "fiction-fictionhot",
          component: resolve =>
            require(["@/pages/application/fiction/fictionhot"], resolve)
        },
        {
          path: "chapterlist",
          name: "fiction-chapterlist",
          component: resolve =>
            require(["@/pages/application/fiction/chapterlist"], resolve)
        },
        {
          path: "content",
          name: "content-examine",
          component: resolve =>
            require(["@/pages/application/contentExamine"], resolve)
        }
      ]
    },
    // 广告素材运营路由规则
    {
      path: "/offerMaterial",
      name: "offerMaterial",
      redirect: {
        name: "offerMaterial-offerMaterialList"
      },
      component: resolve => require(["@/pages/offerMaterial"], resolve),
      children: [
        {
          path: "offerMaterialList",
          name: "offerMaterial-offerMaterialList",
          component: resolve =>
            require(["@/pages/offerMaterial/offerMaterialList"], resolve)
        },
        {
          path: "offerMaterialDetail",
          name: "offerMaterial-offerMaterialDetail",
          component: resolve =>
            require(["@/pages/offerMaterial/offerMaterialDetail"], resolve)
        }
      ]
    },
    // 广告素材运营路由规则
    {
      path: "/cashFinance",
      name: "cashFinance",
      redirect: {
        name: "cashFinance-list"
      },
      component: resolve => require(["@/pages/cashFinance"], resolve),
      children: [
        {
          path: "cashFianceList",
          name: "cashFinance-list",
          component: resolve =>
            require(["@/pages/cashFinance/list"], resolve)
        },
        {
          path: "cashFinanceTurnover",
          name: "cashFinance-turnover",
          component: resolve =>
            require(["@/pages/cashFinance/turnover"], resolve)
        },
        {
          path: "cashFinanceTurnoverCash",
          name: "cashFinance-turnover-cash",
          component: resolve =>
            require(["@/pages/cashFinance/turnoverCash"], resolve)
        },
        {
          path: "cashFinanceBill",
          name: "cashFinance-bill",
          component: resolve =>
            require(["@/pages/cashFinance/bill"], resolve)
        },
        {
          path: "cashFinanceItem",
          name: "cashFinance-item",
          component: resolve =>
            require(["@/pages/cashFinance/item"], resolve)
        },
        {
          path: "transactionList",
          name: "transaction-list",
          component: resolve =>
            require(["@/pages/cashFinance/transactionList"], resolve)
        },
        {
          path: "paymentsList",
          name: "payments-list",
          component: resolve =>
            require(["@/pages/cashFinance/paymentsList"], resolve)
        }
      ]
    },
    {
      path: "/releaselog",
      name: "releaselog",
      component: resolve => require(["@/pages/releaselog"], resolve)
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js